import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: process.env.NODE_ENV === 'production' ? 'hash' : 'hash', // TODO: muze byt problem s reloadem aplikace na nekterych webovych serverech
  base: process.env.BASE_URL
})

export default router
